<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer002">
<p class="ORIM-Dedication--Front-Matter-" lang="en-US"><span class="CharOverride-1">for BRYN,</span></p>
<p class="ORIM-Dedication--Front-Matter-" lang="en-US"><span class="CharOverride-1">who talked of the minefield that led to the decision</span></p>
<p class="ORIM-Dedication--Front-Matter-" lang="en-US"><span class="CharOverride-1">and</span></p>
<p class="ORIM-Dedication--Front-Matter-" lang="en-US"><span class="CharOverride-1">In Memoriam</span></p>
<p class="ORIM-Dedication--Front-Matter-" lang="en-US"><span class="CharOverride-1">E.R.D. and L.B.B. Friends</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// EmeraldDecision1.vue?4abb059c